module.exports = __webpack_public_path__ + "70b817f507cccd1621b94e49171c09f3.pdf";